module.exports = __webpack_public_path__ + "img/blue-information-circle.ec9999c2.svg";